(() => {
  if (window.RaidageCollectionQuickAdd) return;
  const pending = new WeakSet();
  function close(selector) {
    selector.classList.remove('active');
    selector.closest('.product-card')?.querySelector('[data-quick-add-toggle]')?.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', async event => {
    const toggle = event.target.closest('[data-quick-add-toggle]');
    if (toggle) {
      event.preventDefault();
      const selector = toggle.closest('.product-card')?.querySelector('[data-size-selector]');
      if (!selector) return;
      document.querySelectorAll('[data-size-selector]').forEach(other => { if (other !== selector) close(other); });
      selector.classList.toggle('active');
      toggle.setAttribute('aria-expanded', String(selector.classList.contains('active')));
      return;
    }
    const button = event.target.closest('button.size-selector__size');
    if (!button) {
      if (!event.target.closest('.product-card')) document.querySelectorAll('[data-size-selector]').forEach(close);
      return;
    }
    event.preventDefault();
    if (button.disabled || pending.has(button) || button.dataset.variantAvailable !== 'true') return;
    const selector = button.closest('[data-size-selector]');
    const error = selector.querySelector('[data-quick-add-error]');
    const status = selector.querySelector('[data-quick-add-status]');
    const originalText = button.textContent;
    const background = button.style.background;
    const color = button.style.color;
    const showError = message => { if (error) { error.textContent = message; error.hidden = !message; } };
    pending.add(button);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    showError('');
    if (status) status.textContent = 'Adding to cart';
    try {
      if (!window.RaidageCart) throw new Error('Cart is unavailable. Please reload and try again.');
      const result = await window.RaidageCart.add(button.dataset.variantId, button);
      if (!button.isConnected) return;
      button.textContent = '✓';
      button.style.background = '#000';
      button.style.color = '#fff';
      if (status) status.textContent = 'Added to cart';
      if (result.warning) showError(result.warning);
      await new Promise(resolve => setTimeout(resolve, 500));
      if (!result.warning) close(selector);
    } catch (failure) {
      showError(failure.message || 'Unable to confirm this add. Check your cart before trying again.');
      if (status) status.textContent = '';
    } finally {
      button.textContent = originalText;
      button.style.background = background;
      button.style.color = color;
      button.disabled = button.dataset.variantAvailable !== 'true';
      button.removeAttribute('aria-busy');
      pending.delete(button);
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const selector = event.target.closest('[data-size-selector]');
    if (!selector) return;
    close(selector);
    selector.closest('.product-card')?.querySelector('[data-quick-add-toggle]')?.focus();
  });
  window.RaidageCollectionQuickAdd = true;
})();
